import React from 'react';

export default function Loader() {
  return (
    <div className="overlay">
      <div className="scaling-dots">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
